// extracted by mini-css-extract-plugin
module.exports = {"SideDrawerToggle":"SideDrawerToggle_SideDrawerToggle__1sjmh"};